const LOGOS = {
    dark: 'https://developers.google.com/static/youtube/images/developed-with-youtube-sentence-case-dark.png',
    light: 'https://developers.google.com/static/youtube/images/developed-with-youtube-sentence-case-light.png',
};

function DevelopedWithYouTube({
    variant = 'dark',
    className = '',
    imageClassName = 'h-auto w-[172px]',
}) {
    const logoSrc = LOGOS[variant] || LOGOS.dark;

    return (
        <a
            href="https://www.youtube.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Learnforest uses YouTube API Services"
            className={`inline-flex shrink-0 items-center ${className}`.trim()}
        >
            <img
                src={logoSrc}
                alt="Developed with YouTube"
                className={imageClassName}
            />
        </a>
    );
}

export default DevelopedWithYouTube;
